module.exports = __webpack_public_path__ + "img/wide.b81d485d.jpg";